export default __webpack_public_path__ + "static/media/testing.d12e57fc.jpg";